<form [formGroup]="form" (submit)="onConfirmClick()">
  <div>
    <div class="row">
      <div class="col-12">
        <h2 mat-dialog-title class="w-100 flex justify-content-between">
          {{ data.title }}
          <button
            mat-icon-button
            mat-dialog-close
            aria-label="Close dialog"
            class="close"
          >
            <mat-icon>close</mat-icon>
          </button>
        </h2>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <table class="lum-table lum-table--classic striped">
          <tr class="table__head-row">
            <th>SKU</th>
            <th>Warehouse</th>
            <th>Location</th>
          </tr>
          <tbody formArrayName="lineItems">
            <ng-container *ngFor="let item of lineItems; let i = index">
              <tr [formGroupName]="i">
                <td>
                  {{ item?.value?.internalSku }}
                </td>
                <td>
                  <mat-select
                    class="lum-select"
                    formControlName="warehouseId"
                    (selectionChange)="onSelectWarehouseEvent($event, i)"
                  >
                    <mat-option
                      *ngFor="let warehouse of warehouses"
                      [value]="warehouse.id"
                    >
                      {{ warehouse.location_name }}
                    </mat-option>
                  </mat-select>
                </td>
                <td>
                  <mat-select class="lum-select" formControlName="locationId">
                    <mat-option
                      *ngFor="
                        let location of locations[item?.value?.warehouseId ?? 0] ??
                          []
                      "
                      [value]="location.id"
                    >
                      {{ location.location_name }}
                    </mat-option>
                  </mat-select>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
    </div>
    <div class="row pt-5">
      <div class="col-12">
        <mat-dialog-content class="mat-typography">
          <h4>{{ data.message }}</h4>
          <div class="block pb-2">
            <input
              type="text"
              class="lum-input"
              matInput
              formControlName="inputValue"
            />
          </div>
        </mat-dialog-content>
        <mat-dialog-actions align="end">
          <button
            mat-button
            type="submit"
            [disabled]="form.invalid"
            class="lum-button lum-button--danger lum-button--medium mx-1"
          >
            <ng-container *ngIf="data.module; else defaultLabel">
              Delete {{ data.module }}
            </ng-container>
            <ng-template #defaultLabel> Delete </ng-template>
          </button>
        </mat-dialog-actions>
      </div>
    </div>
  </div>
</form>
